/**
 * Created by stoneWang on 2017/8/16.
 * @desc  所有的ajax请求请都调用此文件的方法
 */

var request = require("superagent");
import {openNotice} from 'Utils';

/**
 * @param url //API的路径
 * @param options
 *        {
 *          method: <String> 'post', //请求方式，如果是get方法此参数可不传。
 *                                     可能值：'post'、'post'、'post_form'、'put'、'delete'
 *          body: <Object> {}, //前端发送到服务器的数据
 *        }
 * @returns {Promise}
 */
export default function ajaxRequest(url, options) {
    const param = options && options.body ? options.body : null;
    const search = options && options.search ? options.search : null;
    const method = options && options.method ? options.method : 'get';

    let urlStr = '';
    if (search) {
        Object.keys(search).forEach(item => {
            urlStr += `&${item}=${search[item]}`;
        });
        url = `${url}?${urlStr.substring(1)}`;
    }
    return new Promise((resolve, reject) => {
        let xhr = null;
        if (method === 'post') {
            xhr = request.post(url);
            param && xhr.send(param);
        }
        if (method === 'put') {
            xhr = request.put(url);
            param && xhr.send(param);
        }
        if (method === 'get') {
            xhr = request.get(url)
            //.set("If-Modified-Since","0")
            //.set("Cache-Control","no-cache");
            param && xhr.query(param);
        }
        if (method === 'delete') {
            xhr = request.delete(url);
            param && xhr.query(param);
        }
        if (method === 'post_form') {
            xhr = request.post(url);
            param && xhr.query(param);
        }

        xhr.set("Content-Type", method === 'post_form' ? "" : "application/json;charset=utf-8").set("token", window.localStorage.getItem("session_token"))
            .end(function (err, res) {
                if (!res) {
                    openNotice('warning', '提示', '无服务！！！');
                    return;
                }
                if ((res.text || '').match('no login')) {
                    openNotice('warning', '提示', '当前会话已失效，请重新登录');
                    window.location.href = "#/";
                    return;
                } else if (err || !res.ok) {
                    console.error("请求失败:\n" + JSON.stringify(res.body));
                    reject(res.body.message);
                } else if (!res.body || !res.body.status) {
                    console.error(res.body ? res.body.message : '');
                    //reject(res.body.message);
                }
                resolve(res.body);
            });
    });
}



// WEBPACK FOOTER //
// ./src/utils/ajaxRequest.js